<template>
  <div class="gold-wrap">
    <a-row :gutter="8" style="margin-bottom: 16px">
      <a-col :span="4">
        <a-input
          placeholder="请输入学生姓名"
          class="filter-selection"
          allow-clear
          v-model="searchForm.studentName"
        />
      </a-col>
      <a-col :span="4">
        <a-input
          placeholder="请输入学生手机号"
          class="filter-selection"
          allow-clear
          v-model="searchForm.phoneNumber"
        />
      </a-col>
      <a-col :span="4">
        <a-select
          class="select-item"
          style="width: 100%"
          v-model="searchForm.gradeId"
          allow-clear
          placeholder="全部年级"
        >
          <a-select-option :value="item.id" v-for="(item,index) in gradeList" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4">
        <template>
          <a-button type="primary" @click="search" style="margin-right: 8px;">
            搜索
          </a-button>
        </template>
        <template>
          <a-button @click="reset" class="ant-btn-secondary">
            重置
          </a-button>
        </template>
      </a-col>
      <a-col :span="8" style="text-align: right">
        <a-button @click="overView" class="ant-btn">
          增减明细总览
        </a-button>
      </a-col>
    </a-row>
    <a-table
      row-key="userId"
      :scroll="scroll"
      :loading="tableLoading"
      :columns="columns"
      :data-source="studentList"
      :pagination="false"
    >
      <div slot="userName" slot-scope="text, row">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ row.userId }}</span>
          </template>
          <span>{{ text }}</span>
        </a-tooltip>
      </div>
      <div slot="origin" slot-scope="text">
        {{ text === 'xkhTeacher' ? '小括狐教师端' : "--" }}
      </div>
      <div slot="studentQr" slot-scope="text, row">
        <a href="javascript:;" @click="showQr(row)">
          查看
        </a>
      </div>
      <div slot="interactedNum" slot-scope="text, row">
        <!-- <a-input-number
          :style="row.inputStyle || {}"
          v-model="row.goldVal"
          type="number"
          :key="row.userId"
        /> -->
        <goldInput :row-key="row.userId" :val="row.goldVal" @goldChange="goldChange" />
        <a href="javascript:;" :disabled="row.addDisable" @click="addGoldSubmit(row)" :style="{ marginLeft: '10px'}">
          增加
        </a>
        <a-button type="link" @click="minusGoldSubmit(row)" class="dangerLink">
          扣减
        </a-button>
        <a href="javascript:;" @click="selDetail(row)">
          增减明细
        </a>
      </div>
    </a-table>
    <div class="pagination">
      <a-pagination
        v-show="pagination.total > 0"
        v-model="pagination.current"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @change="handleChangePageNum"
      />
    </div>

    <!-- 扣减明细弹窗 -->
    <goldDetail :visible.sync="goldDetailVisible" :gold-detail-obj="goldDetailObj" />

    <!-- 扣减明细总览弹窗 -->
    <overView :visible.sync="goldOverViewVisible" />

    <!-- 家长端学生二维码弹框 -->
    <studentQr :visible.sync="studentQrVisible" ref="studentQr" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, onUnmounted } from '@vue/composition-api'
import columns from './columns'
import goldDetail from './coms/goldDetail.vue'
import goldInput from './coms/goldInput.vue'
import overView from './coms/overView.vue'
import studentQr from './coms/studentQr.vue'
import goldLogger from '@/utils/logger/gold.js'

export default {
  name: 'Gold',

  components: {
    goldDetail,
    overView,
    studentQr,
    goldInput
  },

  setup(_, { root, refs }) {
    const state = reactive({
      goldDetailVisible: false, // 扣减明细
      goldDetailObj: {}, // 扣减明细学生数据
      goldOverViewVisible: false, // 扣减明细总览
      scroll: { y: 0 },
      searchForm: {
        studentName: undefined,
        phoneNumber: undefined,
        gradeId: undefined
      },
      tableLoading: false,
      pagination: {
        pageSize: 20,
        total: 0,
        current: 1
      },
      studentList: [],
      gradeList: [],
      studentQrVisible: false // 家长端学生二维码弹框
    })

    const methods = {
      minusGoldSubmit: row => {
        if (row.goldVal < 1) {
          return root.$message.error('扣减金币数量不得小于1')
        }
        if (row.goldVal > row.coinsNum) {
          return root.$message.error('扣减数量不可超过学生当前金币数')
        }
        root.$confirm({
          content: '确认扣减该学生金币吗？',
          okText: '确认',
          cancelText: '取消',
          centered: true,
          onOk: () => {
            root.$service.coin.deductionCoins({ studentId: row.studentId, coinNum: row.goldVal }).then(res => {
              root.$message.success('扣减成功')
              state.studentList[row.fdIndex].coinsNum = row.coinsNum - row.goldVal
              state.studentList[row.fdIndex].goldVal = null
              // methods.getList()
            })
            goldLogger.goldDeclineLogger({
              studentId: row.studentId,
              coinNum: row.goldVal,
              desc: '扣减'
            })
          }
        })
      },
      addGoldSubmit: row => {
        if (row.goldVal < 1) {
          return root.$message.error('增加金币数量不得小于1')
        }
        if (row.goldVal > 1000) {
          return root.$message.error('增加数量不可超过1000')
        }
        root.$confirm({
          content: '确认增加该学生金币吗？',
          okText: '确认',
          cancelText: '取消',
          centered: true,
          onOk: () => {
            root.$service.coin.addCoins({ studentId: row.studentId, coinNum: row.goldVal }).then(res => {
              root.$message.success('增加成功')
              const findex = state.studentList.findIndex(s => s.userId == row.userId)
              if (findex > -1) {
                const ss = state.studentList[findex]
                state.studentList.splice(findex, 1, {
                  ...ss,
                  goldVal: null,
                  addDisable: false,
                  coinsNum: ss.coinsNum + ss.goldVal
                })
              }
            })
            goldLogger.goldDeclineLogger({
              studentId: row.studentId,
              coinNum: row.goldVal,
              desc: '增加'
            })
          }
        })
      },
      getGradeOptions: () => {
        root.$service.courseAndGroup.getParams().then(res => {
          const { gradeList } = res
          state.gradeList = gradeList
        })
      },
      // 获取学生金币列表
      getList: () => {
        state.tableLoading = true
        const params = {
          ...state.searchForm,
          pageSize: state.pagination.pageSize,
          pageNum: state.pagination.current
        }
        root.$service.coin.getCoinList(params).then(res => {
          state.studentList = res.list && res.list.map((k, index) => {
            k.goldVal = null
            k.addDisable = false
            k.fdIndex = index
            return k
          })
          state.pagination = {
            ...state.pagination,
            total: res.itemTotal,
            current: res.pageNum
          }
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          state.tableLoading = false
        })
      },
      search: () => {
        state.pagination.current = 1
        methods.getList()
      },
      reset: () => {
        Object.keys(state.searchForm).forEach(k => {
          state.searchForm[k] = undefined
        })
        methods.search()
      },
      overView: () => {
        state.goldOverViewVisible = true
      },
      setTableHeight: () => {
        const h = document.documentElement.clientHeight || document.body.clientHeight
        state.scroll.y = parseInt(h - 310)
      },
      selDetail: row => {
        state.goldDetailVisible = true
        state.goldDetailObj = row
        goldLogger.goldDeclineDetailLogger()
      },
      handleChangePageNum: () => {
        methods.getList()
      },
      showQr: row => {
        state.studentQrVisible = true
        refs.studentQr.showQr(row)
      },
      goldChange: (key, val) => {
        const findex = state.studentList.findIndex(s => s.userId == key)
        if (findex > -1) {
          const ss = state.studentList[findex]
          state.studentList.splice(findex, 1, {
            ...ss,
            goldVal: val,
            addDisable: val > 1000
          })
        }
      }
    }

    onMounted(() => {
      methods.getGradeOptions()
      methods.setTableHeight()
      methods.getList()
      // 浏览器视口大小改变时调整表格高度
      window.onresize = () => {
        methods.setTableHeight()
      }
    })

    onUnmounted(() => {
      window.onresize = null
    })

    return {
      columns,
      ...methods,
      ...toRefs(state)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/static/css/base.less';
.gold-wrap {
  height: calc(100% - 20px);
  padding: 24px;
  overflow: hidden;
  background: #fff;
  position: relative;
  .gold-action-btn {
    cursor: pointer;
  }
  .pagination {
    text-align: right;
    padding-top: 20px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  .dangerLink{
    color: #ff4d4f;
    margin: 0 4px;
  }
}
</style>